import { useState, useEffect } from "react";
import { getLive } from "../../network/lib/goals.js";
import { handleContent } from "../utils/helper.js";
import parse from "html-react-parser";
import goalBackImg from "../../assests/images/goal/theaim.png";

function Goals() {
  const [goalDetails, setGoalDetails] = useState();

  useEffect(() => {
    !goalDetails && populateGoalDetails();
  }, []);

  function populateGoalDetails() {
    getLive().then((res) => {
      if (res.status == 200) {
        setGoalDetails(res.data);
      }
    });
  }

  const contents = goalDetails && (
    <div className="Row">
      <table
        cellSpacing="0"
        style={{ backgroundImage: `url(${goalBackImg})`,border: '3px solid #fe6902', borderRadius: '40px', 
        backgroundPosition :'right',backgroundRepeat: 'norepeat', paddingLeft: '10px', color: 'black', }}
      >
        <tbody >
          <tr>
            <th scope="col">&nbsp;</th>
          </tr>
          {goalDetails.map((goalDetail) => (
            <tr key={goalDetail.id}>
              <td >
                {parse(`<span class="headings" >${goalDetail.heading}</span>`)}
                {goalDetail.image &&
                  parse(
                    `<img src=${goalDetail.image} style="float: right;width: 350px"/>`
                  )}
                {parse(
                  handleContent(goalDetail.contentTypeId, goalDetail.content)
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );

  return contents;
}

export default Goals;
